import { observer } from "mobx-react";
import * as React from "react";
import { CentralStore } from "../../stores/erros/CentralStore";
import { AppStore } from "../../stores/AppStore";
import { LegislacaoStore } from "../../stores/legislacao/LegislacaoStore";
import { Badge } from "primereact/badge";
import { Menubar } from "primereact/menubar";
import { AppIcon } from "../utils/AppIcon";
import { setupNavbarSubmenuFlip } from "../../utils";

interface Props {
  endMobile: any
  end: any
  start: any
}

@observer
export default class NavMenu extends React.Component<Props, {}> {

  private cleanupSubmenuFlip: (() => void) | null = null;

  async componentDidMount() {

    await CentralStore.load();

    this.cleanupSubmenuFlip = setupNavbarSubmenuFlip();

  }

  componentWillUnmount() {
    this.cleanupSubmenuFlip?.();
  }

  render() {

    const currentArea = AppStore.obs1.location ? AppStore.obs1.location.area : null;
    const isActive = (to?: string) => !!to && !!currentArea && (to === `/${currentArea}` || to.startsWith(`/${currentArea}/`));

    const itemRenderer = (item) => {
      const active = isActive(item.to);
      return (
        <a className={`flex align-items-center p-menuitem-link ${active ? 'menu-item-current' : ''}`} onClick={() => AppStore.setLocation(item.to)}>
          <span className={item.icon} />
          <span className="mx-2">{item.label}</span>
          {item.badge && <Badge className="ml-auto" value={item.badge} />}
          {item.shortcut &&
            <span className="new-tag-nav-new ml-auto">{item.shortcut}</span>}
        </a>
      )
    };

    const itemUnicRenderer = (item) => {
      const active = isActive(item.to);
      return (
        <a className={`flex align-items-center p-menuitem-link ${active ? 'menu-item-current' : ''}`} onClick={() => AppStore.setLocation(item.to)}>
          {item.icon}
          <span className="mx-2">{item.label}</span>
        </a>
      );
    };

    const itemRendererDivider = (item) => (
      <div
        className="flex align-items-center render-unic"
        role="presentation"
        aria-hidden="true"
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
        onKeyDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
      >
        <span className="mx-2">{item.label}</span>
      </div>
    );

    const dashboard = {
      label: 'Dashboard',
      icon: <img src="/icons/painel.png" width={24} />,
      template: itemUnicRenderer,
      to: '/dashboard'
    }

    const empresas = {
      label: 'Empresas',
      icon: <img src="/icons/escritorio.png" width={24} />,
      template: itemUnicRenderer,
      to: '/empresas'
    }

    const declaracoes = {
      label: 'Declarações',
      icon: <img src="/images/money.png" width={24} />,
      items: [
        {
          label: 'PGDAS-D',
          template: itemRenderer,
          to: '/pgdas'
        },
        {
          label: 'SPED',
          template: itemRenderer,
          to: '/sped'
        },
        {
          label: 'FGTS',
          template: itemRenderer,
          to: '/fgts-digital'
        },
        {
          label: 'DEI',
          template: itemRenderer,
          shortcut: 'Novo',
          to: '/dei'
        },
      ]
    }

    const xmls = {
      label: 'XMLs',
      icon: <img src="/images/xml.svg" width={24} />,
      items: [
        {
          label: 'Importação de Xmls',
          template: itemRenderer,
          to: '/imports'
        },
        {
          label: 'XML Integração',
          template: itemRenderer,
          to: '/xml-integration'
        },
        {
          label: 'Manifestações',
          template: itemRenderer,
          to: '/historico-notas'
        },
        {
          label: 'NF-e, NFC-e, CT-e e NFS-e',
          template: itemRenderer,
          to: '/nfes'
        },
        {
          label: 'Portal da NF-e',
          template: itemRenderer,
          to: '/portal-nfe'
        },
        {
          label: 'Solicitações de Arquivos',
          items: [
            {
              label: 'Pará',
              template: itemRendererDivider
            },
            { separator: true },
            {
              label: 'Solicitações SEFA',
              template: itemRenderer,
              to: '/solicitacoes-sefa'
            },
            {
              label: 'NFS-e Prefeitura',
              template: itemRenderer,
              to: '/nfse-prefeitura'
            }
          ]
        }
      ]
    }

    const calculos = {
      label: 'Cálculos',
      icon: <img src="/images/calculos.svg" width={24} />,
      items: [
        {
          label: 'Memória de Cálculos',
          template: itemRenderer,
          to: '/memoria-calculo'
        },
        {
          label: 'Resultados de Cálculos',
          template: itemRenderer,
          to: '/resultados'
        }
      ]
    }

    const itemsLegisPA = [
      {
        label: 'Arquivos',
        items: [
          {
            label: 'Cálculo Icms',
            template: itemRenderer,
            command: () => { LegislacaoStore.get_pdf("icms") }
          },
          {
            label: 'Decreto Icms',
            template: itemRenderer,
            command: () => { LegislacaoStore.get_pdf("decreto") }
          }
        ]
      },
      {
        label: 'Tabelas',
        items: [
          {
            label: 'ALÍQUOTAS DE ICMS',
            template: itemRenderer,
            to: '/icms-aliquotas'
          },
          {
            label: 'CNAE',
            template: itemRenderer,
            to: '/cnae'
          },
          {
            label: 'CST',
            items: [
              {
                label: 'CST - CSON/ICMS',
                template: itemRenderer,
                to: '/cst-cson'
              },
              {
                label: 'CST - PIS/COFINS',
                template: itemRenderer,
                to: '/pis-cofins'
              },
              {
                label: 'CST - ORIGEM',
                template: itemRenderer,
                to: '/cst-origem'
              }
            ]
          },
          {
            label: 'EANS',
            template: itemRenderer,
            to: '/eans'
          },
          {
            label: 'TABELA TIPI',
            template: itemRenderer,
            to: '/tipi'
          },
          {
            label: 'MVAs',
            template: itemRenderer,
            to: '/mvas-pa'
          },
          {
            label: 'MONOFÁSICO',
            template: itemRenderer,
            to: '/monofasico-simples'
          },
          {
            label: 'TRIBUTAÇÃO NACIONAL',
            template: itemRenderer,
            to: '/tributacao-nacional'
          },
          {
            label: 'CFOPS',
            template: itemRenderer,
            to: '/cfops'
          }
        ]
      }
    ]

    const itemsLegisRS = [
      {
        label: 'CNAE',
        template: itemRenderer,
        to: '/cnae'
      },
      {
        label: 'CST',
        items: [
          {
            label: 'CST - CSON/ICMS',
            template: itemRenderer,
            to: '/cst-cson'
          },
          {
            label: 'CST - PIS/COFINS',
            template: itemRenderer,
            to: '/pis-cofins'
          },
          {
            label: 'CST - ORIGEM',
            template: itemRenderer,
            to: '/cst-origem'
          }
        ]
      },
      {
        label: 'EANS',
        template: itemRenderer,
        to: '/eans'
      },
      {
        label: 'MVAs',
        template: itemRenderer,
        to: '/mvas-rs'
      },
      {
        label: 'TRIBUTAÇÃO NACIONAL',
        template: itemRenderer,
        to: '/tributacao-nacional'
      },
      {
        label: 'CFOPS',
        template: itemRenderer,
        to: '/cfops'
      }
    ]

    const legislacaoAdmin = {
      label: 'Legislação',
      icon: <img src="/images/legislacao.png" width={24} />,
      items: [
        {
          label: 'Pará',
          items: itemsLegisPA
        },
        {
          label: 'Rio Grande do Sul',
          items: itemsLegisRS
        },
      ]
    }

    const relatorios = {
      label: 'Relatórios',
      icon: <img src="/images/relatorio.png" width={24} />,
      items: [
        {
          label: 'Cadastros',
          items: [
            {
              label: 'Clientes',
              template: itemRenderer,
              to: '/clientes'
            },
            {
              label: 'Fornecedores',
              template: itemRenderer,
              to: '/fornecedores'
            },
          ]
        },
        {
          label: 'Conversor SPED',
          items: [
            {
              label: 'SPED para XLSX',
              template: itemRenderer,
              to: '/sped-planilha'
            },
            {
              label: 'XLSX para SPED',
              template: itemRenderer,
              to: '/sped-txt'
            },
          ]
        },
        {
          label: 'CNDS',
          template: itemRenderer,
          to: '/cnds'
        },
        {
          label: 'Geral',
          template: itemRenderer,
          to: '/relatorios'
        },
        {
          label: 'Situação Fiscal (RFB)',
          template: itemRenderer,
          to: '/sitfis'
        },
        {
          label: 'Parcelamentos',
          template: itemRenderer,
          shortcut: 'Novo',
          to: '/relatorio_parcelamento'
        },
        {
          label: 'Integrações',
          items: [
            {
              label: 'Configuração de Token',
              template: itemRenderer,
              to: '/integracoes'
            },
            {
              label: 'Confirmação de Chave e Tokens',
              template: itemRenderer,
              shortcut: 'Novo',
              to: '/confirmacao-chaves-tokens'
            },
          ]
        },
        {
          label: 'Empresas',
          items: [
            {
              label: 'Faixa Simples Nacional',
              template: itemRenderer,
              shortcut: 'Novo',
              to: '/faixa-simples'
            },
          ]
        },
        {
          label: 'Manifestação',
          items: [
            {
              label: 'Relatório de Cálculo',
              template: itemRenderer,
              shortcut: 'Novo',
              to: '/calculo-manifestacao'
            },
          ]
        }
      ]
    }

    const admin = {
      label: 'Admin',
      icon: <img src="/images/admin.svg" width={24} />,
      items: [
        {
          label: 'Ajustes Sped',
          template: itemRenderer,
          to: '/ajustes-sped'
        },
        {
          label: 'Contas',
          template: itemRenderer,
          to: '/contas'
        },
        {
          label: 'Empresas',
          template: itemRenderer,
          to: '/empresas-admin'
        },
        {
          label: 'Legis Web - Lucro',
          template: itemRenderer,
          to: '/legis-web-lucro'
        },
        {
          label: 'Legis Web - Simples',
          template: itemRenderer,
          to: '/legis-web-simples'
        },
        {
          label: 'Pauta RS',
          template: itemRenderer,
          to: '/pauta-rs'
        },
        {
          label: 'Tabela Sped',
          template: itemRenderer,
          to: '/tabelas-sped'
        },
        {
          label: 'Tabela Simples',
          template: itemRenderer,
          to: '/tabela-simples'
        },
        {
          label: 'Tabela Simples Excesso',
          template: itemRenderer,
          to: '/tabela-simples-excesso'
        },
        {
          label: 'Formas de cálculos',
          items: [
            {
              label: 'PA',
              template: itemRenderer,
              to: '/calcs'
            },
            {
              label: 'RS',
              template: itemRenderer,
              to: '/calcs-rs'
            }
          ]
        },
        {
          label: 'Produtos',
          items: [
            {
              label: 'PA',
              template: itemRenderer,
              to: '/produtos'
            },
            {
              label: 'RS',
              template: itemRenderer,
              to: '/produtos-rs'
            }
          ]
        },
        {
          label: 'Variáveis',
          items: [
            {
              label: 'PA',
              template: itemRenderer,
              to: '/vars'
            },
            {
              label: 'FCP',
              template: itemRenderer,
              to: '/vars-fcp'
            },
            {
              label: 'CÁLCULO',
              template: itemRenderer,
              to: '/vars-calc'
            }
          ]
        },
      ]
    }

    const items = [
      dashboard,
      empresas,
      declaracoes,
      xmls,
      calculos,
      legislacaoAdmin,
      relatorios
    ]

    const itemsAdmin = [
      dashboard,
      empresas,
      declaracoes,
      xmls,
      calculos,
      legislacaoAdmin,
      admin
    ]

    const itemsUser = [
      dashboard
    ]

    let userPermissao = AppStore.obs1.usuario ? AppStore.obs1.usuario.user_empresa : false;

    const itensHeader = AppStore.obs1.usuario.admin
      ? itemsAdmin
      :  userPermissao
        ? itemsUser
        : items

    return (

      <>

        {AppStore.obs1.usuario && (

          <>

            <div className={AppStore.obs1.usuario.admin ? "responsive-navbar-mobile-admin" : "responsive-navbar-mobile"} style={{ width: "100%" }}>
              <Menubar model={itensHeader} start={this.props.start} end={this.props.endMobile} className="navbar-prime" />
            </div>

            <div className={AppStore.obs1.usuario.admin ? "responsive-navbar-admin" : "responsive-navbar"} style={{ width: "100%" }}>
              <Menubar model={itensHeader} start={this.props.start} end={this.props.end} className="navbar-prime" />
            </div>

          </>

        )}

      </>

    );

  }

}
